import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbsoluteLoaderComponent } from '../components/absolute-loader/absolute-loader.component';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { StorageService } from './storage.service';
import { DecimalsPipe } from '../pipes/decimals.pipe';

@NgModule({
  imports: [CommonModule, MatButtonModule, AbsoluteLoaderComponent, RouterModule, DecimalsPipe],
  providers: [StorageService],
  exports: [AbsoluteLoaderComponent, MatButtonModule, RouterModule, CommonModule, DecimalsPipe]
})
export class SharedModule {}
